import EventMatcherList from './view';


const EventMatcherPage = {
    name: 'EventMatcher',
    list: EventMatcherList,
};

export default EventMatcherPage;